import React from 'react';
import { TextBox } from 'components/form/TextBox';

export const IncomeForm = props => {
  const {
    incomeInput,
    onChangeIncome,
    isOptional,
    placeholder,
    outerClassName,
    fullWidth,
  } = props;
  const defaultText = 'Annual Income';
  const optionalText = isOptional ? '(Optional)' : '';
  return (
    <div className="profile-overview-textbox inputContainer incomeTextBox">
      <TextBox
        type="text"
        datatestid="annualIncome"
        className="text-left"
        placeholder={placeholder || `${defaultText} ${optionalText}`}
        value={incomeInput.displayValue}
        onChange={onChangeIncome}
        error={incomeInput.error}
        outerClassName={outerClassName}
        fullWidth={fullWidth}
      />
    </div>
  );
};
